import AddressRecord from '../records/address';
import ListRecord from '../records/list';
import InventoryRecord from '../records/inventory';
import OrderRecord from '../records/order';
import SaleRecord from '../records/sale';
import UserRecord from '../records/user';

export default {
  address: AddressRecord,
  account: UserRecord, 
  list: ListRecord,
  inventory: InventoryRecord,
  order: OrderRecord,
  sale: SaleRecord
};
